import styled from "styled-components";

export const DevelopersBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 20px 15px;
`;
